import {
  Component,
  DestroyRef,
  Input,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { listCompanyObjectsSuccess } from 'src/app/core/actions/auth.actions';
import { injectListCompanyObjectsMutation } from 'src/app/api/queries/user-api.queries';

import { AppFeatures } from 'src/app/core/app.features';
import { AppState } from 'src/app/reducers';
import { ChangePasswordDialogComponent } from '../../popups/change-password-dialog/change-password-dialog.component';
import { DialogService } from '@sui/dialog';
import { AuthFlowService } from 'src/app/core/services/auth-flow.service';
import { ObjectEditorService } from 'src/app/core/services/object-editor.service';
import { UserWorkspacesService } from 'src/app/core/services/user-workspaces.service';
import { RecentObjectsService } from 'src/app/core/services/recent-objects.service';
import { Store } from '@ngrx/store';
import { User } from 'src/app/core/models/core.models';
import { selectUser } from 'src/app/core/reducers';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';

@Component({
  selector: 'app-dropdown-user',
  templateUrl: './dropdown-user.component.html',
  styleUrls: ['./dropdown-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DropdownUserComponent {
  @Input() closeMethod!: () => void;

  AppFeatures = AppFeatures;

  private destroyRef = inject(DestroyRef);
  private dialogService = inject(DialogService);
  private listCompanyObjectsMutation = injectListCompanyObjectsMutation();
  private userWorkspaces = inject(UserWorkspacesService);
  private recentObjects = inject(RecentObjectsService);
  private authFlow = inject(AuthFlowService);

  user: User;

  constructor(
    private store: Store<AppState>,
    private editService: ObjectEditorService,
  ) {}

  ngOnInit() {
    this.store
      .select(selectUser)
      .pipe(
        tap((user) => (this.user = user)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  onUserSettings() {
    this.closeMethod();
    this.editService.editUser(this.user.id);
  }

  onChangePassword() {
    this.closeMethod();

    this.dialogService.openTabsDialog(ChangePasswordDialogComponent, {
      data: {},
      closeOnClick: false,
      closeOnEscape: true,
      width: '20vw',
      height: '45vh',
      minWidth: 300,
      minHeight: 600,
      maxWidth: 400,
      maxHeight: 600,
    });
  }

  onLogout() {
    this.closeMethod();
    this.authFlow.logout();
  }

  toggleCompanyObjectsView(event: any) {
    event.stopPropagation();
  }

  handleCompanyObjectsToggle(checked: boolean) {
    // `mutateAsync` so closing the dropdown mid-request cannot drop the request
    // or the follow-up below.
    this.listCompanyObjectsMutation
      .mutateAsync(checked)
      .then((response) => {
        this.store.dispatch(
          listCompanyObjectsSuccess({
            listCompanyObjects: response.list_company_objects,
          }),
        );

        // The toggle changes which objects the user may see, so both lists have
        // to be refetched.
        this.userWorkspaces.invalidate();
        this.recentObjects.invalidate();
      })
      .catch(() => {});
  }

  hasPerm(perm: AppFeatures) {
    return this.user.feature_components?.[perm] === true;
  }
}
